/**
 * CTASection — final call to action with an aurora-glow card.
 */
import { Aurora } from '@/components/Aurora';
import { GlassButton } from '@/components/GlassButton';
import { Reveal } from '@/components/Reveal';

export function HomeCTA(): JSX.Element {
  return (
    <section className="relative py-24 md:py-32 border-t border-honey-400/10">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="relative isolate overflow-hidden rounded-3xl border border-honey-400/20 bg-ink-900/40 p-10 md:p-16 text-center scanlines">
          <div className="absolute inset-0 -z-10 opacity-60">
            <Aurora colorStops={['#00f0ff', '#aaff00', '#ff2e88']} amplitude={1.0} blend={0.5} />
          </div>
          <Reveal>
            <h2 className="font-display text-4xl md:text-6xl font-extrabold tracking-tight text-balance text-white">
              INSERT COIN · <br />
              <span className="text-gradient-warm">今天开机</span>
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-5 text-lg text-cream-200/90 max-w-2xl mx-auto leading-relaxed">
              30 秒注册，10 门基础课免费玩。无信用卡，浏览器即开即用。
            </p>
          </Reveal>
          <Reveal delay={0.14}>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <GlassButton to="/app" size="lg" variant="solid">
                INSERT COIN →
              </GlassButton>
              <GlassButton to="/pricing" size="lg">看会员计划</GlassButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
